export default __webpack_public_path__ + "static/media/phone.0e8a6830.svg";